import React, { Component } from 'react'
import $ from 'jquery'
import { DragDropContext, Droppable, Draggable } from '@hello-pangea/dnd'
import popupDrag from '../../../static/image/popup_drag.png'
import '../../../static/css/popup.css';


// a little function to help us with reordering the result
const reorder = (list, startIndex, endIndex) => {
  const result = Array.from(list)
  const [removed] = result.splice(startIndex, 1)
  result.splice(endIndex, 0, removed)

  return result
}

class OptionDragV2 extends Component {
  componentDidMount() {
    var items = this.props.items
    
    this.setState({ items: items })

    $('.menuGrpPopup2closeBtn').off('click').on('click', () => {
      this.setState({ stop: 0 })
      $('.menuGrpPopup2').addClass('hide')
    })
  }
  componentDidUpdate(_, prevState) {
    var items = this.props.items
    var states = 1
    var prevItems = prevState.items
    var prevStates = prevState.states
    var stop = this.state.stop
    var selectId = $("#menuDrgSelect .selectText").attr("data-id")
    var prevSelectId = prevState.selectId
    
    if(items === prevItems) {
      states = 2
    }

    if(selectId !== prevSelectId) {
      this.setState({ selectId: selectId, stop: 0 })
    }

    if(states !== prevStates && stop === 0) {
      if(items.length > 0) {
        items.sort(function(a, b) {
          return parseFloat(a.exposSeq) - parseFloat(b.exposSeq)
        })
      }

      this.setState({ items: items, states: states })
    }
  }

  constructor(props) {
    super(props)

    var items = this.props.items

    this.state = {
      items: items,
      states: 1,
      stop: 0,
      selectId: 0
    }
    this.onDragEnd = this.onDragEnd.bind(this)
  }

  onDragEnd(result) {
    // dropped outside the list
    if (!result.destination) {
      return
    }

    const items = reorder(
      this.state.items,
      result.source.index,
      result.destination.index
    )

    this.setState({ items: items, stop: 1 })
  }

  render() {
    let items = this.state.items


    let listNumber = items.map((value, index) => {
      var number = index + 1
      return (
        <li key={ index }>{ number }</li>
      )
    })
    
    return (
      <DragDropContext onDragEnd={this.onDragEnd}>
        <ul className='dragNumberBox'>
          { listNumber }
        </ul>
        <Droppable droppableId="menuGrpDragBox">
          {(provided, snapshot) => (
            <ul className='popupDrag' {...provided.droppableProps} ref={provided.innerRef}>
              {items.map((item, index) => (
                <Draggable key={ item.id } draggableId={`item-${item.id}`} index={index}>
                  {(provided, snapshot) => (
                    <li
                      data-id={item.id}
                      ref={provided.innerRef}
                      {...provided.draggableProps}
                      {...provided.dragHandleProps}
                    >
                      <img className='popupDragImg' src={ popupDrag } alt="팝업드래그" />
                      <div>
                        <p className="popupDragTitle popupMenuDragTitle" data={item.id}>{item.optName}</p>
                      </div>
                    </li>
                  )}
                </Draggable>
              ))}
              {provided.placeholder}
            </ul>
          )}
        </Droppable>
      </DragDropContext>
    )
  }
}

export { OptionDragV2 }
